import {
    Directive,
    ElementRef,
    Input,
    OnInit,
    Renderer2
} from '@angular/core';

export type Size = 'sm' | 'md' | 'lg';
export type Status =
  | 'primary'
  | 'danger'
  | 'warning'
  | 'success'
  | 'info'
  | 'basic';

@Directive({
  selector: '[ihoInput]',
})
export class InputDirective implements OnInit {
//   el = inject(ElementRef)
//   renderer = Inject(Renderer2)
  input = this.el.nativeElement

  constructor(private el: ElementRef, private renderer: Renderer2) {
    
  }

  @Input() set status(status: Status) {
    this.renderer.addClass(this.input, status);
  }

  @Input() set size(size: Size) {
    this.renderer.addClass(this.input, size);
  }

  ngOnInit(): void {
    this.renderer.addClass(this.input, 'iho-input');
  }
}
